const fs = require('fs');
const { join } = require('path');
const Reader = require('properties-reader');

const DEFAULT_PROFILE = undefined;
const { LC_PROFILE } = process.env;
const lcMergedPropertiesPath = join(
  process.cwd(),
  './config/lc-merged.properties'
);
const hasPropertiesFile = fs.existsSync(lcMergedPropertiesPath);
const lcMergedProperties = hasPropertiesFile
  ? Reader(lcMergedPropertiesPath)._properties // eslint-disable-line no-underscore-dangle
  : {};
const lcEnv = LC_PROFILE || lcMergedProperties.LC_PROFILE || DEFAULT_PROFILE;

// Hardcode ETCD service rather than using serviceKeys since this is needed
// first to provide serviceKey support in lc-http/lc-service-client.
let url = 'https://uw2.lc-config-nprd.lendingcloud.us/api/config/default';
let pegUrl = 'demo-default.password-encryption-gateway-nprd.lendingcloud.us';

// All (production) environments starting with `prod`
if (/^prod/.test(lcEnv)) {
  url =
    'https://prod-default.lc-config-prod.lendingcloud.us/api/config/default';

  pegUrl = 'prod-default.password-encryption-gateway-prod.lendingcloud.us';
}

/**
 * @namespace etcdClient
 * @description `config.etcdClient` configuration object.
 * @property {String} etcdClient.url ETCD service URL
 * @property {String} etcdClient.pegUrl PEG service URL
 * @property {Number} etcdClient.refreshTime Polling interval duration in
 * milliseconds (default 60000ms or 1 min).
 * @property {Number} etcdClient.timeout Service time till timeout in
 * milliseconds (default 20000ms).
 */
module.exports = {
  url,
  pegUrl,
  // milliseconds * seconds * minutes * days (1 min)
  refreshTime: 1000 * 60 * 1 * 1,
  timeout: 20000,
  logger: {
    console: false,
  },
};

